export const PROCESES = 'PROCESES';
export const CREATE_PROCESS = 'CREATE_PROCESS';



// WEBPACK FOOTER //
// ./src/actions/proceses/actionTypes.js